import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Navbar } from './components/navbar/navbar';
import { Footer } from './components/footer/footer';
import { useUserInfo } from '@/context/user-info';
import { lazy, Suspense } from 'react';
import CookieWrapper from './components/cookies-banner/CookieWrapper';
import { HelpcenterLayout } from './pages/helpcenter/HelpcenterLayout';
import { FaqDataProvider } from '@/context/faq-data.provider';
import { CollectionRouteWrapper } from './pages/helpcenter/wrappers/CollectionRouteWrapper';
import { ArticleRouteWrapper } from './pages/helpcenter/wrappers/ArticleRouteWrapper';

const LazyHome = lazy(() =>
  import('./pages/home/home').then((module) => ({ default: module.Home })),
);
const LazyHowItWorks = lazy(() =>
  import('./pages/how-it-works/how-it-works').then((module) => ({ default: module.HowItWorks })),
);
const LazyAboutApp = lazy(() =>
  import('./pages/about-app/about-app').then((module) => ({ default: module.AboutApp })),
);
const LazyDrivingLessons = lazy(() =>
  import('./pages/driving-lessons/driving-lessons').then((module) => ({
    default: module.DrivingLessons,
  })),
);
const LazyNotFound = lazy(() =>
  import('./pages/not-found').then((module) => ({ default: module.NotFound })),
);

export const App = () => {
  const { userLanguage } = useUserInfo();

  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div className="w-full h-screen flex items-center justify-center">Loading...</div>
        }
      >
        <div className="size-full min-h-screen bg-white flex flex-col justify-between">
          <Navbar />
          <CookieWrapper />
          <Routes>
            <Route index element={<LazyHome />} />
            <Route path={`/${userLanguage}`} element={<LazyHome />} />
            <Route path={`/${userLanguage}/`} element={<LazyHome />} />
            <Route
              path={`/${userLanguage}/how-it-works`}
              element={
                <Navigate
                  to={`/${userLanguage}/how-it-works/${userLanguage === 'fr' ? 'paris' : 'barcelona'}`}
                  replace
                />
              }
            />
            <Route path={`/${userLanguage}/how-it-works/:cityName`} element={<LazyHowItWorks />} />
            <Route path={`/${userLanguage}/about-app`} element={<LazyAboutApp />} />
            <Route path={`/${userLanguage}/driving-lessons`} element={<LazyDrivingLessons />} />
            <Route
              path={`/${userLanguage}/faq`}
              element={
                <FaqDataProvider>
                  <HelpcenterLayout />
                </FaqDataProvider>
              }
            >
              <Route path=":collectionSlug" element={<CollectionRouteWrapper />}>
                <Route path=":articleSlug" element={<ArticleRouteWrapper />} />
              </Route>
            </Route>
            <Route path="*" element={<LazyNotFound />} />
            <Route path="/not-found" element={<LazyNotFound />} />
          </Routes>
          <Footer />
        </div>
      </Suspense>
    </BrowserRouter>
  );
};
